<script lang="ts" setup>
import Loader from "@/components/Loader.vue";

defineOptions({
  name: 'DemoApp'
});

window.appConfig = {
  apiUrl: import.meta.env.VITE_API_URL || 'localhost:44363',
  token: ''
};

</script>

<template>
  <!--  <login-banner/>-->
  <div>
    <loader size="s"  text="Palun oodake laen andmeid ... "/>  
  </div>
  <div>
  <div>
    <loader size="m"  text="Palun oodake laen andmeid ... "/>  
  </div>
  <div>
    <loader size="l"  text="Palun oodake laen andmeid ... "/>  
  </div>
  </div>
  
  <!--  <sign-in/>-->
</template>

<style scoped>
div {
  height: 200px;
  position: relative;
}
</style>
